import { AppStateCreator } from "../types";
import { InvoiceSlice } from "../types";
import { initialState, useAppStore } from ".";
import { IInvoiceOperation } from "@/types/invoice-operation.type";

export const createInvoiceSlice: AppStateCreator<InvoiceSlice> = (set) => ({
  invoice: {
    ...initialState.invoice,
    setPage: (page) => {
      set((state) => ({
        invoice: {
          ...state.invoice,
          page: page,
        },
      }));
    },
    setFilters: (newFilters) =>
      set((state) => ({
        invoice: {
          ...state.invoice,
          filters: {
            ...state.invoice.filters,
            ...newFilters,
          },
        },
      })),
    openModalInvoice: () => {
      set((state) => ({
        invoice: {
          ...state.invoice,
          modals: {
            ...state.invoice.modals,
            isOpen: true,
          },
        },
      }));
    },
    openModalInvoiceEdit: (invoice: IInvoiceOperation) => {
      set((state) => ({
        invoice: {
          ...state.invoice,
          modals: {
            ...state.invoice.modals,
            isOpen: true,
            editingInvoice: invoice,
          },
        },
      }));
    },
    openModalInvoiceCancellation: (invoiceId: string) => {
      set((state) => ({
        invoice: {
          ...state.invoice,
          modals: {
            ...state.invoice.modals,
            cancellationIsOpen: true,
            editingInvoice: invoiceId,
          },
        },
      }));
    },
    closeModalInvoice: () => {
      set((state) => ({
        invoice: {
          ...state.invoice,
          modals: {
            ...state.invoice.modals,
            isOpen: false,
            editingInvoice: null,
            cancellationIsOpen: false,
          },
        },
      }));
    },
  },
});

export const useInvoiceFilters = () =>
  useAppStore((state) => state.invoice.filters);
export const useInvoiceModals = () =>
  useAppStore((state) => state.invoice.modals);
export const useInvoiceState = () => useAppStore((state) => state.invoice);
